export const Endpoint = ({ projectId, taskId }: Payload) =>
    `/vscanner/api/v2/projects/${projectId}/tasks/${taskId}/start`;

export type Payload = {
    projectId: string;
    taskId: string;
};

export type Response = void;
